module.exports = "<router-outlet></router-outlet>\r\n<ngx-loading-bar></ngx-loading-bar>\r\n"